import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { Reuniao } from 'src/app/core/reuniao';
import { ReuniaoService } from 'src/app/services/reuniao/reuniao.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { PessoaFisica } from '../../../core/pessoa-fisica';

@Component({
  selector: 'app-cadastrar-reuniao',
  templateUrl: './cadastrar-reuniao.component.html',
  styleUrls: ['./cadastrar-reuniao.component.css']
})
export class CadastrarReuniaoComponent implements OnInit {

  reuniao: Reuniao;

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  mostrarBotaoCadastrar = true
  mostrarBotaoAtualizar = true;

  isAtualizar: boolean = false;
  area: string;
  menu: string;
  constructor(
    private reuniaoService: ReuniaoService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastService: ToastService
  ) {

  }

  ngOnInit() {
    this.inicializarObjetos()
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

    if (!this.perfilAcesso.insere) {
      this.mostrarBotaoCadastrar = false;
    }

    if (!this.perfilAcesso.altera) {
      this.mostrarBotaoAtualizar = false;
    }

    let idReuniao: number;
    this.area = this.getArea();
    idReuniao = this.activatedRoute.snapshot.queryParams.idReuniao ? this.activatedRoute.snapshot.queryParams.idReuniao : null;
    if (idReuniao) {
      this.isAtualizar = true;
      this.reuniaoService.getById(idReuniao).subscribe((reuniao: Reuniao) => {
        this.reuniao = reuniao;
        this.tratarDados();
        if (!this.reuniao.relator) {
          this.reuniao.relator = new PessoaFisica();          
        }
        if (!this.reuniao.acoesReuniao) {
          this.reuniao.acoesReuniao = [];
        }
        if (!this.reuniao.participantes) {
          this.reuniao.participantes = [];
        }
      });
    }
    
    
  }

  getMenu(): string {
    const primeiroSegmento = this.router.url.split('/')[1];
    return primeiroSegmento.startsWith('menu') ? primeiroSegmento : undefined;
  }

  private getArea(): string {
    this.menu = this.getMenu();
    return this.menu && this.menu == "menu-sap" ? 'S' : (this.menu && this.menu == "menu-pedagogico" ? 'P' : null);
  }

  inicializarObjetos() {
    this.reuniao = new Reuniao();
    this.reuniao.relator = new PessoaFisica();
    this.reuniao.acoesReuniao = [];
    this.reuniao.participantes = [];
  }
  mostrarBotaoLimpar() {
    if (this.isAtualizar) return false;
    if (!this.mostrarBotaoAtualizar) return false;
    if (!this.mostrarBotaoCadastrar) return false;

    return true;
  }

  cadastrar() {
    this.tratarDados();
    this.reuniaoService.cadastrar(this.reuniao).subscribe(() => {
      const rota = this.menu ? this.menu+'/reunioes':'reunioes';
      this.router.navigate([rota]);
      this.toastService.showSucesso("Reuniao cadastrada com sucesso");
    });
  }

  tratarDados() {
    this.reuniao.area = this.area;
    this.reuniao.dataProximaReuniao = this.getData(this.reuniao.dataProximaReuniao);
    this.reuniao.dataInicio = this.getData(this.reuniao.dataInicio);
    this.reuniao.dataFim = this.getData(this.reuniao.dataInicio);
    if (this.reuniao && this.reuniao.acoesReuniao && this.reuniao.acoesReuniao.length > 0) {
      this.reuniao.acoesReuniao.forEach(acaoReuniao => {
        acaoReuniao.dataPrazo = this.getData(acaoReuniao.dataPrazo);
      })
    }
  }


  limpar() {
    this.inicializarObjetos();
  }

  cancelar() {
    const rota = this.menu ? this.menu+'/reunioes':'reunioes';
    this.router.navigate([rota]);
  }

  atualizar() {
    this.tratarDados();
    this.reuniaoService.alterar(this.reuniao).subscribe(() => {
      const rota = this.menu ? this.menu+'/reunioes':'reunioes';
      this.router.navigate([rota]);
      this.toastService.showSucesso("Reuniao atualizada com sucesso");
    });
  }

  getData(data: any) {
    if (data) {
      if (data instanceof Date) {
        return data; 
      }
      const dataString: string = data;
      const [year, month, day] = dataString.split('-').map(Number);
      const newDate = new Date(year, month - 1, day);
      return newDate;
    }
    return data;
  }
    
}
